<div class="flex flex-row w-full justify-center items-center h-full">
  <div
    class="flex flex-col-reverse items-center sm:flex-row justify-between gap-[2rem] w-4/5 sm:w-3/4 lg:w-1/2 bg-white p-4 sm:p-8
           lg:p-12 rounded-lg">
    <div class="w-full flex flex-row justify-center mt-[-9rem] sm:mt-0">

      <form [formGroup]="loginForm" #loginNgForm="ngForm" class="flex flex-col items-center justify-center">


        <img class="mt-10 md:mt-0 " src="assets/image/logo-black.svg" alt="logo">


        <div class="flex flex-col items-center gap-2 mt-[2rem]">
          <mat-form-field appearance="outline" class="inputField">
            <mat-label for="username">{{"username or email" | translate}}</mat-label>
            <input matInput type="text" [(ngModel)]="loginRequestData!.username" name="username" #username="ngModel"
                   [ngModelOptions]="{standalone: true}" required>
            <mat-error *ngIf="username && username.errors">
              <span *ngIf="username.errors['required']">{{"Required Field" | translate}}s</span>
            </mat-error>


          </mat-form-field>


          <mat-form-field appearance="outline" class="inputField">
            <mat-label>{{"Password" | translate}}</mat-label>
            <input [formControlName]="'password'" minlength=8
                   [(ngModel)]="loginRequestData!.password" id="password" matInput type="password" name="password" autocomplete="on"
                   required>

            <mat-error *ngIf="f['password'].touched && f['password'].invalid">
              <div *ngIf="f['password'].errors && f['password'].errors['required']">
                {{"Required Field" | translate}}
              </div>
            </mat-error>
          </mat-form-field>
        </div>
        <div class="w-full mt-5 flex flex-row justify-center">
          <button mat-raised-button color="primary" class="w-1/2" (click)="login()">
            {{"login-btn" | translate}}
          </button>
        </div>
        <div class="mt-2 text-center">
          <a routerLink="../forgot-password" class=" text-[#3E7479]">{{"forgot-password" | translate}}</a>
        </div>

      </form>

    </div>
    <div class="flex flex-row w-full justify-center items-center sm:py-5 mt-8">
      <img src="assets/image/machine.png" alt="login-image" class="scale-75 md:scale-110">
    </div>
  </div>
</div>

